import request from '@/utils/request'
import qs from 'qs'

export function getFillRateByMonthApi(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/list-by-month',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getFillRateByDayApi(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/list-by-day',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getFillRateByDayApiExcel(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/list-by-day-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getFillRatePieChartApi(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/occupied-room-level-in-range',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getFillRateLineChartApi(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/histogram_occupied',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getFillRateBarChartApi(query) {
  return request({
    url: '/report-service/v1/occupied-room-level-report/revenue_room_level',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getAgentRevenueApi(query) {
  return request({
    url: '/report-service/v1/report/agent',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getAgentRevenueApiExcel(query) {
  return request({
    url: '/report-service/v1/report/agent/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getAgentRevenueLineChartApi(query) {
  return request({
    url: '/report-service/v1/report/agent/increase',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getAgentRevenueBarChartApi(query) {
  return request({
    url: '/report-service/v1/report/agent/histogram',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getSourceRevenueApi(query) {
  return request({
    url: '/report-service/v1/report/source-group',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getSourceRevenueApiExcel(query) {
  return request({
    url: '/report-service/v1/report/source-group/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getSourceRevenueLineChartApi(query) {
  return request({
    url: '/report-service/v1/report/source-group/increase',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}

export function getDailyRoomReportApi(query) {
  return request({
    url: '/report-service/v1/report/daily-room',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getDailyRoomReportApiExcel(query) {
  return request({
    url: '/report-service/v1/report/daily-room/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getBookingIncomingApi(query) {
  return request({
    url: '/report-service/v1/report/booking-incoming',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getBookingIncomingExcel(query) {
  return request({
    url: '/report-service/v1/report/booking-incoming/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getDailyDepositApi(query) {
  return request({
    url: '/report-service/v1/deposit-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getDailyDepositApiExcel(query) {
  return request({
    url: '/report-service/v1/deposit-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getUserDepositApi() {
  return request({
    url: '/report-service/v1/cancel-transaction-report/list-cancel-user',
    method: 'get'
  })
}
export function getFreeListApi(query) {
  return request({
    url: '/report-service/v1/report/free-room',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getFreeListApiExcel(query) {
  return request({
    url: '/report-service/v1/report/free-room/to-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
